import { motion } from 'motion/react';
import { ScrollReveal } from '@/components/motion/scroll-reveal';
import { timelineItems } from '../data/about-data';

export function AboutStory() {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <ScrollReveal className="text-center mb-16">
          <p className="text-sm font-semibold text-blue-600 dark:text-blue-400 tracking-wider uppercase mb-3">
            Nuestra Trayectoria
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Una historia de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-violet-600">
              crecimiento constante
            </span>
          </h2>
          <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            Desde una idea en Bolivia hasta una plataforma regional. Cada ano nos acerca más a
            nuestra vision de democratizar el pricing inteligente.
          </p>
        </ScrollReveal>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-blue-500/50 via-violet-500/50 to-cyan-500/50 md:-translate-x-px" />

          <div className="space-y-12">
            {timelineItems.map((item, index) => (
              <motion.div
                key={item.year}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`relative flex flex-col md:flex-row items-start ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Dot on line */}
                <div className="absolute left-4 md:left-1/2 w-3 h-3 -translate-x-1.5 md:-translate-x-1.5 top-2">
                  <div
                    className={`w-full h-full rounded-full bg-gradient-to-br ${item.gradient} shadow-lg`}
                  />
                  <div
                    className={`absolute inset-0 rounded-full bg-gradient-to-br ${item.gradient} animate-ping opacity-30`}
                  />
                </div>

                {/* Content card */}
                <div
                  className={`ml-12 md:ml-0 md:w-[calc(50%-2rem)] ${
                    index % 2 === 0 ? 'md:pr-8 md:text-right' : 'md:pl-8'
                  }`}
                >
                  <div className="relative rounded-xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900/50 p-6 shadow-sm hover:shadow-lg hover:border-blue-200 dark:hover:border-blue-500/30 transition-all duration-300">
                    <span
                      className={`inline-block text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r ${item.gradient} mb-1`}
                    >
                      {item.year}
                    </span>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
